<template>
  <b-list-group-item
    class="bg-secondary py-1 px-0 font-weight-bold position-sticky top-0"
  >
    <div class="list-group-item-inner d-flex align-items-center justify-content-end">
      <div class="preview-col"></div>
      <div class="first-col d-inline-flex align-items-center justify-content-center">
        <slot name="first" />
      </div>
      <div class="toggle-col"></div>
      <div class="flex-grow-1 position-relative d-flex align-items-center" style="white-space: nowrap; gap: 4px;">
        UMR
        <BDXPendingColumnFilter
          :value="columnFilters.umr || ''"
          :is-open="showFilters.umr"
          placeholder="Search by UMR"
          @toggle="toggleFilter('umr')"
          @apply="(v) => applyFilter('umr', v)"
          @clear="clearFilter('umr')"
        />
      </div>
      <div class="rc-col bdx-col position-relative d-flex align-items-center" style="white-space: nowrap; gap: 4px;">
        Risk Code
        <BDXPendingColumnFilter
          :value="columnFilters.risk_code || ''"
          :is-open="showFilters.risk_code"
          placeholder="Search by Risk Code"
          @toggle="toggleFilter('risk_code')"
          @apply="(v) => applyFilter('risk_code', v)"
          @clear="clearFilter('risk_code')"
        />
      </div>
      <div class="cc-col bdx-col position-relative d-flex align-items-center" style="white-space: nowrap; gap: 4px;">
        Catastrophe Code
        <BDXPendingColumnFilter
          :value="columnFilters.cat_code || ''"
          :is-open="showFilters.cat_code"
          placeholder="Search by Cat Code"
          @toggle="toggleFilter('cat_code')"
          @apply="(v) => applyFilter('cat_code', v)"
          @clear="clearFilter('cat_code')"
        />
      </div>
      <div class="sn-col bdx-col position-relative d-flex align-items-center" style="white-space: nowrap; gap: 4px;">
        Section Number
        <BDXPendingColumnFilter
          :value="columnFilters.section_no || ''"
          :is-open="showFilters.section_no"
          placeholder="Search by Section #"
          @toggle="toggleFilter('section_no')"
          @apply="(v) => applyFilter('section_no', v)"
          @clear="clearFilter('section_no')"
        />
      </div>
      <div class="lu-col bdx-col position-relative d-flex align-items-center" style="white-space: nowrap; gap: 4px;">
        Lead Underwriter
        <BDXPendingColumnFilter
          :value="columnFilters.lead_underwriter || ''"
          :is-open="showFilters.lead_underwriter"
          placeholder="Search by Lead Underwriter"
          @toggle="toggleFilter('lead_underwriter')"
          @apply="(v) => applyFilter('lead_underwriter', v)"
          @clear="clearFilter('lead_underwriter')"
        />
      </div>
    </div>
  </b-list-group-item>
</template>

<script>
import { defineComponent, inject, reactive, onMounted, onUnmounted } from '@vue/composition-api'

import BDXPendingColumnFilter from '../BDXPendingColumnFilter.vue'

import { BDXStatusPendingManagerInjectionKey } from './BDXStatusPendingManager.constants'

export default defineComponent({
  name: 'BDXStatusPendingManagerListHeader',
  components: {
    BDXPendingColumnFilter
  },
  setup() {
    const { columnFilters, setColumnFilter } = inject(BDXStatusPendingManagerInjectionKey)

    const showFilters = reactive({
      umr: false,
      risk_code: false,
      cat_code: false,
      section_no: false,
      lead_underwriter: false
    })

    const closeAll = () => {
      Object.keys(showFilters).forEach((k) => { showFilters[k] = false })
    }

    const toggleFilter = (key) => {
      const wasOpen = showFilters[key]
      closeAll()
      if (!wasOpen) showFilters[key] = true
    }

    const applyFilter = (key, value) => {
      setColumnFilter(key, value)
      showFilters[key] = false
    }

    const clearFilter = (key) => {
      setColumnFilter(key, '')
      showFilters[key] = false
    }

    const handleOutsideClick = () => closeAll()

    onMounted(() => document.addEventListener('click', handleOutsideClick))
    onUnmounted(() => document.removeEventListener('click', handleOutsideClick))

    return {
      columnFilters,
      showFilters,
      toggleFilter,
      applyFilter,
      clearFilter
    }
  }
})
</script>

<style scoped>
.list-group-item {
  z-index: 99;
}

.list-group-item >>> .list-group-item-inner {
  display: flex;
  align-items: center;
}

.list-group-item >>> .list-group-item-inner > div.preview-col {
  min-width: 44px;
  width: 44px;
}

.list-group-item >>> .list-group-item-inner > div.first-col {
  min-width: 30px;
  width: 30px;
  margin-right: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.list-group-item >>> .list-group-item-inner .custom-checkbox {
  width: 20px;
  margin-left: 0;
}

.list-group-item >>> .list-group-item-inner .custom-checkbox > label {
  padding-left: 0;
  margin-bottom: 0;
}

.list-group-item >>> .list-group-item-inner > div.toggle-col {
  min-width: 50px;
  width: 50px;
}

.list-group-item >>> .list-group-item-inner > div.flex-grow-1 {
  min-width: 160px;
}
</style>
